import { CRMIdModel, GetContactOptoutStatusModel } from "../../../types";
import { APIRequest, APIRequestMethod } from "../APIRequest"
import { Client } from "../Client"

class CRMAPI {
  CreateContact(firstName: string, lastName: string, email: string, phone: string, userId?: string): Promise<CRMIdModel> {
    return Client.Request<CRMIdModel>(new APIRequest(APIRequestMethod.POST, '/api/crm/contacts', {
      FirstName: firstName,
      LastName: lastName,
      Phone: phone,
      Email: email,
      UserId: userId
    }));
  }

  GetOptoutStatus(contactId: string, userId: string): Promise<GetContactOptoutStatusModel> {
    return Client.Request<GetContactOptoutStatusModel>(new APIRequest(APIRequestMethod.POST, '/api/crm/contacts/get_optout_status', {
      ContactId: contactId,
      UserId: userId
    }));
  }

  OptOut(contactId: string, userId: string): Promise<GetContactOptoutStatusModel> {
    return Client.Request<GetContactOptoutStatusModel>(new APIRequest(APIRequestMethod.POST, '/api/crm/contacts/opt_out', {
      ContactId: contactId,
      UserId: userId
    }));
  }

  CreateBasicPropertyRequirement(contactId: string, beds: number, baths: number, cars: number, postCodes: string[], userId?: string): Promise<CRMIdModel> {
    return Client.Request<CRMIdModel>(new APIRequest(APIRequestMethod.POST, `/api/crm/contacts/${contactId}/property_requirements/basic`, {
      UserId: userId,
      Beds: beds,
      Baths: baths,
      Cars: cars,
      Postcodes: postCodes
    }));
  }
}

export { CRMAPI }